(function () {
    function loadScript(src, callback) {
        var script = document.createElement("script");
        script.src = src;
        script.onload = callback;
        document.head.appendChild(script);
    }

    function loadJQueryAndSlick(callback) {
        if (window.jQuery === undefined) {
            loadScript("https://code.jquery.com/jquery-3.6.0.min.js", function () {
                console.log("jQuery carregado!");
                loadSlick(callback);
            });
        } else {
            loadSlick(callback);
        }
    }

    function loadSlick(callback) {
        if (!window.jQuery.fn.slick) {
            loadScript("https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js", function () {
                console.log("Slick.js carregado!");
                callback();
            });
        } else {
            callback();
        }
    }

    loadJQueryAndSlick(function () {
        $(document).ready(function () {
            console.log("Iniciando Slick.js...");

            $('.product-stories-wrapper').slick({
                infinite: true,
                variableWidth: true,
                slidesToScroll: 1,
                arrows: true,
                nextArrow: `
                    <button type="button" class="slick-next" aria-label="Next" role="button">
                        <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M7.75 1.34375 L6.25 2.65625 L14.65625 12 L6.25 21.34375 L7.75 22.65625 L16.75 12.65625 L17.34375 12 L16.75 11.34375 Z"></path>
                        </svg>
                    </button>
                `,
                prevArrow: `
                    <button type="button" class="slick-prev" aria-label="Previous" role="button">
                        <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M7.75 1.34375 L6.25 2.65625 L14.65625 12 L6.25 21.34375 L7.75 22.65625 L16.75 12.65625 L17.34375 12 L16.75 11.34375 Z"></path>
                        </svg>
                    </button>
                `,
            });

            window.storiesSlider = $('.stories-wrapper').slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                nextArrow: `
                    <button type="button" class="slick-next" aria-label="Next" role="button">
                        <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M7.75 1.34375 L6.25 2.65625 L14.65625 12 L6.25 21.34375 L7.75 22.65625 L16.75 12.65625 L17.34375 12 L16.75 11.34375 Z"></path>
                        </svg>
                    </button>
                `,
                prevArrow: `
                    <button type="button" class="slick-prev" aria-label="Previous" role="button">
                        <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M7.75 1.34375 L6.25 2.65625 L14.65625 12 L6.25 21.34375 L7.75 22.65625 L16.75 12.65625 L17.34375 12 L16.75 11.34375 Z"></path>
                        </svg>
                    </button>
                `,
            })
            .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                // Pausar o vídeo do slide atual
                const currentVideo = $('.product-story-video').eq(currentSlide).find('video').get(0);
                if (currentVideo) {
                    currentVideo.pause();
                    currentVideo.currentTime = 0;
                    currentVideo.muted = true;
                }
            })
            .on('afterChange', function (event, slick, currentSlide) {
                // Tocar o vídeo do novo slide
                const newVideo = $('.product-story-video').eq(currentSlide).find('video').get(0);
                if (newVideo) {
                    newVideo.currentTime = 0;
                    newVideo.muted = false;
                    newVideo.play();
                }
            });

            // Fechar Stories
            $('[data-close-stories]').on('click', function () {
                $('[data-stories]').removeClass('show-stories');
                $('body').removeClass('stories-opened');

                // Pausar vídeos HTML5
                $('.stories-wrapper video').each(function () {
                    this.pause();
                    this.currentTime = 0;
                    this.muted = true;
                });

                // Parar vídeos do YouTube
                $('.youtube-video').each(function () {
                    this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
                });
            });

            // Abrir Stories e dar play no vídeo correspondente
            $('[data-open-stories]').on('click', function () {
                const index = parseInt($(this).attr('data-open-stories'), 10);
                $('[data-stories]').addClass('show-stories');
                $('body').addClass('stories-opened');

                setTimeout(() => {
                    window.storiesSlider.slick('slickGoTo', index);
                    // Dar play no vídeo do slide aberto
                    const openVideo = $('.product-story-video').eq(index).find('video').get(0);
                    if (openVideo) {
                        openVideo.currentTime = 0;
                        openVideo.muted = false;
                        openVideo.play();
                    }
                }, 100);
            });

            console.log("Slick.js inicializado!");
        });
    });
})();
